import { Skeleton, SkeletonGroup, SkeletonText } from "./Skeleton";
import styles from "./presets.module.scss";

/** An invitation card: 5:7 face with centred text lines. */
export function CardSkeleton({ width = "100%" }: { width?: string }) {
  return (
    <span className={styles.card} style={{ width }} aria-hidden="true">
      <Skeleton width="38%" height="0.55rem" />
      <Skeleton width="62%" height="1.6rem" />
      <Skeleton width="22%" height="0.9rem" />
      <Skeleton width="58%" height="1.6rem" />
      <Skeleton width="44%" height="0.55rem" style={{ marginTop: "1rem" }} />
    </span>
  );
}

/** Rows of a list/table: avatar, two text lines, trailing action. */
export function ListSkeleton({ rows = 5, label = "Loading" }: { rows?: number; label?: string }) {
  return (
    <SkeletonGroup label={label} className={styles.list}>
      {Array.from({ length: rows }, (_, i) => (
        <span key={i} className={styles.row}>
          <Skeleton width="2.2rem" height="2.2rem" radius="50%" />
          <span className={styles.rowText}>
            <Skeleton width={`${46 + ((i * 17) % 30)}%`} height="0.8rem" />
            <Skeleton width={`${28 + ((i * 11) % 20)}%`} height="0.65rem" />
          </span>
          <Skeleton width="4.5rem" height="1.9rem" radius="0.35rem" />
        </span>
      ))}
    </SkeletonGroup>
  );
}

/** Form sections: a heading then label + input pairs. */
export function FormSkeleton({ sections = 3, fields = 3, label = "Loading" }: { sections?: number; fields?: number; label?: string }) {
  return (
    <SkeletonGroup label={label} className={styles.form}>
      {Array.from({ length: sections }, (_, s) => (
        <span key={s} className={styles.section}>
          <Skeleton width="9rem" height="1.1rem" />
          {Array.from({ length: fields }, (_, f) => (
            <span key={f} className={styles.field}>
              <Skeleton width="6rem" height="0.65rem" />
              <Skeleton height="2.5rem" radius="0.4rem" />
            </span>
          ))}
        </span>
      ))}
    </SkeletonGroup>
  );
}

/** Panel body: a few paragraphs. */
export function PanelSkeleton({ label = "Loading" }: { label?: string }) {
  return (
    <SkeletonGroup label={label} className={styles.panel}>
      <Skeleton width="45%" height="0.7rem" />
      <SkeletonText lines={3} />
      <Skeleton height="2.4rem" radius="0.4rem" />
      <SkeletonText lines={2} />
    </SkeletonGroup>
  );
}
